export const subjectOptions = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Bangla" },
    { value: "2", label: "English" },
    { value: "3", label: "Mathematics" },
    { value: "4", label: "Economics" },
    { value: "5", label: "Chemistry" },
];
export const codeOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "00524" },
    { value: "2", label: "00525" },
    { value: "3", label: "00526" },
    { value: "4", label: "00527" },
    { value: "5", label: "00528" },
];
export const classOptions = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Play" },
    { value: "2", label: "Nursery" },
    { value: "3", label: "One" },
    { value: "4", label: "Two" },
    { value: "5", label: "Three" },
];
export const genderOptions = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Male" },
    { value: "2", label: "Female" },
    { value: "3", label: "Other" },

];
export const bloodOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "A+" },
    { value: "2", label: "A-" },
    { value: "3", label: "B+" },
    { value: "4", label: "B-" },
    { value: "5", label: "O+" },
    { value: "6", label: "O-" },
    { value: "7", label: "AB+" },

];
export const religionOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Islam" },
    { value: "2", label: "Hindu" },
    { value: "3", label: "Christian" },
    { value: "4", label: "Buddish" },
    { value: "5", label: "Other" },
];
export const sectionOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Pink" },
    { value: "2", label: "Blue" },
    { value: "3", label: "Red" },
    { value: "4", label: "Rose" },
    { value: "5", label: "Bird" },
];
export const expanseOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Salary" },
    { value: "2", label: "Transport" },
    { value: "3", label: "Maintanance" },
    { value: "4", label: "Purchase" },
    { value: "5", label: "Utilities" },
];

export const statusOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Paid" },
    { value: "2", label: "Due" },
    { value: "3", label: "Others" },

];
export const attendenceSection = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "A" },
    { value: "2", label: "B" },
    { value: "3", label: "C" },
    { value: "4", label: "D" },

];
export const sessionOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "2016-2017" },
    { value: "2", label: "2017-2018" },
    { value: "3", label: "2018-2019" },
    { value: "4", label: "2020-2021" },

];
export const nextSessionOptions = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "2021-2022" },
    { value: "2", label: "2022-2023" },
    { value: "3", label: "2023-2025" },
    { value: "4", label: "2025-2027" },

];
export const userOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "Super Admin" },
    { value: "2", label: "Admin" },
    { value: "3", label: "User" },

];
export const monthOption = [
    { value: "", label: "Please Select *" },
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "April" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },

];
